export default __webpack_public_path__ + "static/media/Snd_CS.e800b755.mp3";